import React from "react";

export default () => {

    return <svg xmlns="http://www.w3.org/2000/svg" width="20.666" height="19.818" viewBox="0 0 20.666 19.818">
        <g transform="translate(1 1)">
            <path id="Path_53" data-name="Path 53" d="M13.7,30.848A.848.848,0,1,1,12.848,30,.848.848,0,0,1,13.7,30.848Z" transform="translate(-6.061 -13.879)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
            <path id="Path_54" data-name="Path 54" d="M30.2,30.848A.848.848,0,1,1,29.348,30,.848.848,0,0,1,30.2,30.848Z" transform="translate(-13.228 -13.879)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
            <path id="Path_55" data-name="Path 55" d="M1.5,1.5H4.894L7.168,12.861a1.7,1.7,0,0,0,1.7,1.366h8.247a1.7,1.7,0,0,0,1.7-1.366l1.358-7.119H5.742" transform="translate(-1.5 -1.5)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
        </g>
    </svg>;

}
